<app-view-dashboard-component>
  <div modalTitle>
    Yksityisyys
  </div>
  <app-privacy></app-privacy>
</app-view-dashboard-component>